import React, { Fragment, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./timesheet.css";
import FadingSpinner from "./common/FadingSpinner/FadingSpinner";
import LabeledValue from "./common/LabeledValue/LabeledValue";
import { parseHours } from "../helpers/time";
import { UpdateStatus } from "./timesheets/helpers/enum";
import {
  calculateTimesheetStatus
  // parseCostCentre
} from "./timesheets/helpers/helpers";
import PopupModal from "./common/PopupModal/PopupModal";
import TimesheetStatus from "./timesheets/TimesheetStatus/TimesheetStatus";
import TimesheetFeedback from "./timesheetFeedback";
import { checkIfFeedbackCached } from "../helpers/feedback";
import EnhancedDropdown from "./common/EnhancedDropdown/EnhancedDropdown";
import { isMobileBrowserWidth } from "../helpers/traversingDom";
import { setLastCostCentreInStorage } from "../helpers/sessionStorage";
import { getCostCentreForApprovedTimesheet } from "../helpers/timesheet";
import CandImage from "./documentation/Components/CandImage";

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const fullDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

const displayRate = rate => {
  const priceParts = rate.split(".");
  const pence = priceParts.length === 2 ? priceParts[1].padEnd(2, "0") : "00";
  return `${priceParts[0]}.${pence}`;
};

const decimalTohhmm = dec => {
  const n = new Date(0, 0);
  n.setSeconds(+dec * 60 * 60);
  return n.toTimeString().slice(0, 5);
};

const getDayTypeRowContent = hours => (hours > 0 ? "Worked" : "");

const TimesheetRow = ({ daysProp, rateIdx, rate, isDayType }) => (
  <tr className="timesheet__row">
    <td className="timesheet__elem timesheet__row-header">
      <b>{rate.displayName}</b>
      {`\n£${displayRate(rate.invoice.toString())} ${
        isDayType ? " per day" : " per hour"
      }`}
    </td>
    {daysProp.map((hours, dayIdx) => (
      <td className="timesheet__elem" key={`day_${rateIdx}_${dayIdx}`}>
        {isDayType ? getDayTypeRowContent(hours) : decimalTohhmm(hours)}
      </td>
    ))}
  </tr>
);

const makeRows = ({ rates, columns }) =>
  rates.map((_rate, rateIndex) =>
    days.map((_day, dayIndex) => columns[dayIndex].StandardPayQty[rateIndex])
  );

const displayTimesheetDate = (startDate, daysOffset) => {
  const newDate = new Date(startDate.valueOf());
  newDate.setDate(newDate.getDate() + daysOffset);

  const dayOfMonth = newDate.getDate();
  return `${dayOfMonth}/${newDate.getMonth() + 1}/${String(
    newDate.getFullYear()
  ).substr(2, 2)}`;
};

const UpdateNotification = ({
  tokenStore,
  candidateName,
  candidateRef,
  updateState,
  setUpdateState,
  approveTimesheet,
  rejectTimesheet,
  timesheetRef,
  sortedTimesheetRefs,
  nextTimesheet
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  switch (updateState) {
    case UpdateStatus.Loading:
      return (
        <div className="timesheet__notification-wrapper">
          <div className="timesheet__notification">
            <FadingSpinner />
            <h3 className="timesheet__notification-title tw-text-2xl tw-font-bold">
              Submitting your response
            </h3>
            <h5 className="tw-text-xl tw-font-bold">
              This won't take too long
            </h5>
          </div>
        </div>
      );
    case UpdateStatus.Success:
      return (
        <div className="timesheet__notification-wrapper">
          <div className="timesheet__notification">
            <img
              src="https://hrgo.spacebetween.co.uk/images/icons/timesheet-approve.svg"
              alt="timesheet-approve"
            />
            <h2 className="timesheet__notification-title text-center tw-font-bold tw-text-3xl tw-pb-2 ">
              Timesheet approved
            </h2>
            <b className="text-center">
              Your approval of the timesheet has been submitted successfully.
            </b>
            <b>Thank you.</b>
            {!checkIfFeedbackCached() && (
              <TimesheetFeedback
                tokenStore={tokenStore}
                candidateRef={candidateRef}
                candidateName={candidateName}
                timesheetRef={timesheetRef}
              />
            )}
            <div className="d-flex justify-content-end w-100 align-items-center mr-1">
              <Link
                to="/timesheets"
                className="btn mx-1 my-1 timesheet__nav-back"
                onClick={() => {
                  setUpdateState(UpdateStatus.Hidden);
                }}
              >
                <span className="d-none d-xl-block">Back to overview</span>
                <span className="d-sm-block d-md-block d-lg-block d-xl-none">
                  Overview
                </span>
              </Link>
              <Link
                className="btn btn-primary"
                style={{ fontWeight: "bold" }}
                to={{
                  pathname: `/timesheets/${nextTimesheet}`,
                  state: { sortedTimesheetRefs }
                }}
                onClick={() => {
                  setUpdateState(UpdateStatus.Hidden);
                }}
              >
                Next Timesheet
              </Link>
            </div>
          </div>
        </div>
      );
    case UpdateStatus.Rejected:
      return (
        <div className="timesheet__notification-wrapper">
          <div className="timesheet__notification">
            <img
              src="https://hrgo.spacebetween.co.uk/images/icons/timesheet-reject.svg"
              alt="timesheet-reject"
            />
            <h2 className="timesheet__notification-title text-center tw-text-3xl tw-font-bold tw-pb-4">
              Timesheet rejected
            </h2>
            <b className="text-center">
              Your rejection of the timesheet has been submitted successfully.
            </b>
            <b className="text-center">
              The worker will be informed of the rejection and asked to update
              the timesheet. Thank you.
            </b>
            <div className="d-flex justify-content-center w-100 align-items-center mr-1">
              <Link
                to="/timesheets"
                className="btn mx-1 my-1 timesheet__nav-back"
                onClick={() => {
                  setUpdateState(UpdateStatus.Hidden);
                }}
              >
                <span className="d-none d-xl-block">Back to overview</span>
                <span className="d-sm-block d-md-block d-lg-block d-xl-none">
                  Overview
                </span>
              </Link>
              <Link
                className="btn btn-primary"
                style={{ fontWeight: "bold" }}
                to={{
                  pathname: `/timesheets/${nextTimesheet}`,
                  state: { sortedTimesheetRefs }
                }}
                onClick={() => {
                  setUpdateState(UpdateStatus.Hidden);
                }}
              >
                Next Timesheet
              </Link>
            </div>
          </div>
        </div>
      );
    case UpdateStatus.ErrorApprove:
      return (
        <div className="timesheet__notification-wrapper">
          <div className="timesheet__notification">
            <img
              src="https://hrgo.spacebetween.co.uk/images/icons/timesheet-error.svg"
              alt="timesheet-failed"
            />
            <h2 className="timesheet__notification-title text-center">
              Submission failed
            </h2>
            <b className="text-center">
              There has been an error in submitting your approval of the
              timesheet. Please click on the button below to retry.
            </b>
            <button
              className="btn btn-primary mx-1 my-1"
              onClick={() => {
                setUpdateState(UpdateStatus.Loading);
                approveTimesheet(timesheetRef);
              }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    case UpdateStatus.ErrorReject:
      return (
        <div className="timesheet__notification-wrapper">
          <div className="timesheet__notification">
            <img
              src="https://hrgo.spacebetween.co.uk/images/icons/timesheet-error.svg"
              alt="timesheet-failed"
            />
            <h2 className="timesheet__notification-title text-center">
              Submission failed
            </h2>
            <b className="text-center">
              There has been an error in submitting your rejection of the
              timesheet. Please click on the button below to retry.
            </b>
            <button
              className="btn btn-primary mx-1 my-1"
              onClick={() => {
                setUpdateState(UpdateStatus.Loading);
                rejectTimesheet(timesheetRef);
              }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    case UpdateStatus.Hidden:
      return <></>;
    default:
      return <></>;
  }
};

const RejectionModal = ({
  toggleModal,
  rejectTimesheet,
  setRejectionReason,
  rejectionReason
}) => {
  const inputRef = useRef();

  useEffect(() => {
    inputRef.current.focus();
  });

  return (
    <div className="rejection-modal">
      <h4 className="rejection-modal__title tw-text-2xl tw-font-bold ">
        Reject Timesheet
      </h4>
      <div className="w-100">
        Reason for rejecting timesheet
        <textarea
          ref={inputRef}
          className="rejection-modal__textarea w-100 tw-border-gray-200 tw-border-2 "
          onChange={e => setRejectionReason(e.target.value)}
        ></textarea>
      </div>
      <div className="rejection-modal__buttonContainer">
        <button
          className="btn btn-primary"
          onClick={() => {
            setRejectionReason("");
            rejectTimesheet();
            toggleModal();
            window.scrollTo(0, 0);
          }}
          disabled={rejectionReason.length < 3}
        >
          <b>Reject Timesheet</b>
        </button>
        <b className="rejection-modal__cancel" onClick={toggleModal}>
          Cancel
        </b>
      </div>
    </div>
  );
};

const DesktopTimesheet = ({
  timesheet,
  startDate,
  data,
  className,
  approveTimesheet,
  rejectTimesheet,
  setRejectionReason,
  rejectionReason,
  hasNotPickedCostCentre,
  isDayType
}) => {
  const [isRejectOpen, setRejectOpen] = useState(false);
  const toggleRejectOpen = () => setRejectOpen(!isRejectOpen);

  return (
    <div className="tw-px-4">
      <table className={`table ${className}`}>
        <thead>
          <tr>
            <th className="timesheet__table-header">RATE</th>
            {days.map((day, i) => (
              <th className="timesheet__table-header" key={day}>
                {day} {displayTimesheetDate(startDate, i)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <TimesheetRow
              key={i}
              rateIdx={i}
              rate={timesheet.rates[i]}
              daysProp={row}
              isDayType={isDayType}
            />
          ))}
        </tbody>
      </table>
      {isRejectOpen && (
        <PopupModal>
          <RejectionModal
            toggleModal={toggleRejectOpen}
            rejectTimesheet={() => rejectTimesheet(timesheet.timesheetRef)}
            setRejectionReason={setRejectionReason}
            rejectionReason={rejectionReason}
          />
        </PopupModal>
      )}
      <p className={`timesheet__buttons d-none d-md-flex d-sm-flex`}>
        {timesheet.calculatedStatusCode === "Z10" && (
          <>
            <button
              className="btn btn-primary btn-md"
              style={{ fontWeight: "bold" }}
              onClick={() => {
                window.scrollTo(0, 0);
                approveTimesheet();
              }}
              disabled={hasNotPickedCostCentre}
            >
              Approve timesheet
            </button>
            {!timesheet.rejected && (
              <button
                className="btn btn-md timesheet__reject"
                style={{ fontWeight: "bold" }}
                onClick={toggleRejectOpen}
              >
                Reject timesheet
              </button>
            )}
          </>
        )}
      </p>
    </div>
  );
};

const MobileTimesheet = ({
  timesheet,
  startDate,
  data,
  className,
  approveTimesheet,
  rejectTimesheet,
  setRejectionReason,
  rejectionReason,
  isDayType
}) => {
  const [isRejectOpen, setRejectOpen] = useState(false);
  const toggleRejectOpen = () => setRejectOpen(!isRejectOpen);
  return (
    <div className={`${className} w-100`}>
      {fullDays.map((day, i) => (
        <>
          <span className="timesheet-mobile__dayHeader">
            <b>{day.toUpperCase()}</b>
            {displayTimesheetDate(startDate, i)}
          </span>
          <div className="timesheet-mobile__wrapper">
            <span className="timesheet-mobile__rateTitle">RATE</span>
            {data.map((row, idata) => (
              <div
                className="timesheet-mobile__rate"
                key={`mobilerate${idata}`}
              >
                <div className="timesheet-mobile__rate-displayname">
                  <b>{timesheet.rates[idata].displayName}</b>
                  {`\n£${displayRate(
                    timesheet.rates[idata].invoice.toString()
                  )} per ${isDayType ? "day" : "hour"}`}
                </div>
                <div>
                  <span>
                    {isDayType
                      ? getDayTypeRowContent(row[i])
                      : decimalTohhmm(row[i])}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </>
      ))}
      {isRejectOpen && (
        <PopupModal>
          <RejectionModal
            toggleModal={toggleRejectOpen}
            rejectTimesheet={() => rejectTimesheet(timesheet.timesheetRef)}
            setRejectionReason={setRejectionReason}
            rejectionReason={rejectionReason}
          />
        </PopupModal>
      )}
      <p className="timesheet__buttons">
        {timesheet.calculatedStatusCode === "Z10" && (
          <>
            <button
              className="btn btn-primary btn-md"
              style={{ fontWeight: "bold" }}
              onClick={() => {
                window.scrollTo(0, 0);
                approveTimesheet();
              }}
            >
              Approve
            </button>
            {!timesheet.rejected && (
              <button
                className="btn btn-md timesheet__reject"
                style={{ fontWeight: "bold" }}
                onClick={toggleRejectOpen}
              >
                Reject
              </button>
            )}
          </>
        )}
      </p>
    </div>
  );
};

const Timesheet = ({
  tokenStore,
  timesheet,
  sortedTimesheetRefs,
  nextTimesheet,
  approveTimesheet,
  rejectTimesheet,
  updateState,
  setUpdateState,
  setRejectionReason,
  rejectionReason,
  costCentres,
  pickedCostCentre,
  // setPickedCostCentre,
  hasNotPickedCostCentre,
  hasCostCentres,
  handleOverlay,
  passImage
}) => {
  const startDate = new Date(timesheet.startDate);

  const chargeSummed = timesheet.rates.reduce(
    (_acc, _rateElem, index) =>
      _rateElem.invoice
        ? _acc +
          _rateElem.invoice * timesheet.standardRateTotals[index].invoiceQty
        : _acc,
    0
  );
  const isDayType = timesheet.temporaryVacancyTimeUnitCode === "D";
  const timesheetStatus = calculateTimesheetStatus(timesheet);
  const isApproved = timesheetStatus === "Approved";
  const [
    approvedTimesheetCostCentre,
    setApprovedTimesheetCostCentre
  ] = useState();
  const [isLoadingCostCentre, setLoadingCostCentre] = useState(false);

  const handleCostCentre = async () => {
    if (isApproved) {
      setLoadingCostCentre(true);
      const resp = await getCostCentreForApprovedTimesheet(
        tokenStore.getToken(),
        timesheet.timesheetRef
      );
      setApprovedTimesheetCostCentre(
        resp.timesheet.costCentreCode.numericalCode
          ? `${resp.timesheet.costCentreCode.numericalCode} ${resp.timesheet.costCentreCode.text} - ${resp.timesheet.costCentreCode.letterCode}`
          : "No cost centre"
      );
      setLoadingCostCentre(false);
    }
  };

  // eslint-disable-next-line
  const handleDropdownDefaultValue = () => {
    if (isApproved) {
      return approvedTimesheetCostCentre;
    }
    if (pickedCostCentre) {
      return `${pickedCostCentre.numericalCode} ${pickedCostCentre.text} - ${pickedCostCentre.letterCode}`;
    }
  };

  useEffect(() => {
    handleCostCentre();
  }, []);

  // On first render timesheetState is not populated, so we use `timesheet` instead
  const data = makeRows(timesheet);
  return (
    <Fragment>
      <h2 className="timesheet__title tw-text-2xl tw-mb-4 tw-font-bold ">
        Workers' Timesheets
      </h2>
      <Link
        to="/timesheets"
        className="btn btn-tertiary btn-md timesheet__back"
      >
        Back to overview
      </Link>
      <div className="timesheet__details">
        <div className="timesheet__details-inner">
          <div className="tw-flex sm:tw-flex-row tw-flex-col tw-w-full sm:tw-items-center xs:tw-text-left ">
            {timesheet.image ? (
              <CandImage
                styles="tw-w-28 tw-h-28 tw-mx-0 tw-mr-2 tw-m-0 tw-cursor-pointer"
                handleOverlay={handleOverlay}
                passImage={passImage}
                image={timesheet.image}
                firstName={timesheet.candidateName}
              />
            ) : null}
            <h4 className="tw-text-xl sm:tw-pb-0 tw-pb-6 tw-font-bold">
              {timesheet.candidateName}
            </h4>
          </div>
          <div className="timesheet__status-wrapper">
            <TimesheetStatus status={timesheetStatus} />
          </div>
          <div className="timesheet__details-info">
            <div>
              <LabeledValue
                className="tw-pb-6 tw-text-lg"
                label="job"
                value={timesheet.jobTitle}
                isBold={false}
              />
              <div className="timesheet__charge">
                <LabeledValue
                  className="tw-pb-6 tw-text-lg"
                  label="total charge"
                  value={`£${chargeSummed.toFixed(2)}`}
                  isBold={false}
                />
                {isDayType ? (
                  <LabeledValue
                    label="total days"
                    className="tw-pb-6 tw-text-lg"
                    value={`${`${
                      parseHours(
                        timesheet.standardRateTotals.reduce(
                          (acc, rateElem) =>
                            rateElem.invoiceQty
                              ? acc + rateElem.invoiceQty
                              : acc,
                          0
                        )
                      ).split("h")[0]
                    } days`}`}
                    isBold={false}
                  />
                ) : (
                  <LabeledValue
                    label="total hours"
                    className="tw-pb-6 tw-text-lg"
                    value={`${parseHours(
                      timesheet.standardRateTotals.reduce(
                        (acc, rateElem) =>
                          rateElem.invoiceQty ? acc + rateElem.invoiceQty : acc,
                        0
                      )
                    )}`}
                    isBold={false}
                  />
                )}
              </div>
            </div>
            {hasCostCentres && (
              <div>
                <LabeledValue
                  className="pr-0 mr-1 mr-sm-0 d-flex flex-column "
                  label="Cost Centre"
                  value={
                    <EnhancedDropdown
                      items={costCentres}
                      value={handleDropdownDefaultValue()}
                      setValue={() => "TODO"}
                      className="timesheet__costCentre"
                      extendType={isMobileBrowserWidth() && "center"}
                      disabled={!(timesheet.calculatedStatusCode === "Z10")}
                    >
                      {isLoadingCostCentre ? (
                        <div
                          style={{ height: "19px" }}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <FadingSpinner size={"sm"} />
                        </div>
                      ) : (
                        "Required"
                      )}
                    </EnhancedDropdown>
                  }
                />
              </div>
            )}
          </div>
        </div>
        <DesktopTimesheet
          className="d-none d-md-table d-sm-table"
          timesheet={timesheet}
          startDate={startDate}
          data={data}
          approveTimesheet={tsId => {
            approveTimesheet(tsId);
            setLastCostCentreInStorage(pickedCostCentre);
          }}
          rejectTimesheet={rejectTimesheet}
          setRejectionReason={setRejectionReason}
          rejectionReason={rejectionReason}
          hasNotPickedCostCentre={hasNotPickedCostCentre}
          isDayType={isDayType}
        />
        <MobileTimesheet
          className="d-block d-sm-none"
          timesheet={timesheet}
          startDate={startDate}
          data={data}
          approveTimesheet={tsId => {
            approveTimesheet(tsId);
            setLastCostCentreInStorage(pickedCostCentre);
          }}
          rejectTimesheet={rejectTimesheet}
          setRejectionReason={setRejectionReason}
          rejectionReason={rejectionReason}
          hasNotPickedCostCentre={hasNotPickedCostCentre}
          isDayType={isDayType}
        />
        <UpdateNotification
          tokenStore={tokenStore}
          candidateName={timesheet.candidateName}
          candidateRef={timesheet.candidateRef}
          updateState={updateState}
          setUpdateState={setUpdateState}
          approveTimesheet={approveTimesheet}
          rejectTimesheet={rejectTimesheet}
          timesheetRef={timesheet.timesheetRef}
          sortedTimesheetRefs={sortedTimesheetRefs}
          nextTimesheet={nextTimesheet}
        />
      </div>
    </Fragment>
  );
};

export default Timesheet;
